import auth from './routes/auth';
import orders from './routes/orders';
import customers from './routes/customers';

const routes = [
  {
    path: '/',
    redirect: { name: 'orders' },
  },
  ...auth,
  ...orders,
  ...customers,
];

export default routes;
